import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

// --- Palette de couleurs de l'entreprise ---
const brand = {
  primary: '#1f5493', // bleu principal
  secondary: '#7df3e1', // cyan accent (couleur du logo)
};

// --- Light theme ---
export const lightTheme = createUnifiedTheme({
  // createBaseThemeOptions configure la palette MUI + typographie de base
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light, // hérite de toutes les valeurs par défaut du thème clair

      primary: { main: brand.primary },
      secondary: { main: brand.secondary },

      // Couleurs de la sidebar (MUI — non couverts par les CSS vars BUI)
      navigation: {
        background: '#ffffff', // fond de la sidebar
        indicator: brand.primary, // barre de sélection de l'item actif
        color: '#444444', // texte des items
        selectedColor: brand.primary, // texte de l'item actif
        navItem: {
          hoverBackground: '#f0f0f0', // fond au survol
        },
      },

      // Fond général de l'app (hors sidebar)
      background: {
        default: '#f8f8f8',
        paper: '#ffffff',
      },
    },
  }),

  // Police globale
  fontFamily: 'system-ui, sans-serif',

  // Type de page affiché par défaut (home, service, tool, etc.)
  defaultPageTheme: 'home',

  // Dégradés du bandeau header par type de page
  // genPageTheme({ colors: [haut, bas], shape: forme du SVG décoratif })
  // shapes disponibles : shapes.wave, shapes.wave2, shapes.round
  pageTheme: {
    home: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
    service: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
    tool: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.round,
    }),
    website: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave2,
    }),
    apis: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: [brand.primary, '#0d3a6e'],
      shape: shapes.wave,
    }),
  },
});

// --- Dark theme ---
export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,

      primary: { main: brand.secondary },
      secondary: { main: brand.primary },

      navigation: {
        background: '#1e1e1e',
        indicator: brand.secondary,
        color: '#b5b5b5',
        selectedColor: '#ffffff',
        navItem: {
          hoverBackground: '#2a2a2a',
        },
      },

      background: {
        default: '#121212',
        paper: '#1e1e1e',
      },
    },
  }),

  fontFamily: 'system-ui, sans-serif',
  defaultPageTheme: 'home',

  pageTheme: {
    home: genPageTheme({ colors: ['#1e1e1e', '#2a2a2a'], shape: shapes.wave }),
    service: genPageTheme({
      colors: ['#1e1e1e', '#2a2a2a'],
      shape: shapes.wave,
    }),
    tool: genPageTheme({ colors: ['#1e1e1e', '#2a2a2a'], shape: shapes.round }),
    website: genPageTheme({
      colors: ['#1e1e1e', '#2a2a2a'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#1e1e1e', '#2a2a2a'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#1e1e1e', '#2a2a2a'],
      shape: shapes.wave2,
    }),
    apis: genPageTheme({ colors: ['#1e1e1e', '#2a2a2a'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#1e1e1e', '#2a2a2a'], shape: shapes.wave }),
    other: genPageTheme({ colors: ['#1e1e1e', '#2a2a2a'], shape: shapes.wave }),
  },
});
